import { render, staticRenderFns } from "./WebClientsList.vue?vue&type=template&id=1f350096"
import script from "./WebClientsList.vue?vue&type=script&lang=js"
export * from "./WebClientsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports